// extracted by mini-css-extract-plugin
module.exports = {"tagline":"footer_tagline__2vK3I","heart":"footer_heart__SYRRB","icons":"footer_icons__3XfNB"};